module.exports = __webpack_public_path__ + "img/orthese-plantaire.d5e52373.png";